module.exports = __webpack_public_path__ + "images/note-bottom.gif";